import React from 'react';
import { CATEGORY_SUGGESTIONS, COLUMN_OPTIONS } from './movies-admin/constants';
import MoviesAdminCtaSection from './movies-admin/components/MoviesAdminCtaSection';
import MoviesAdminHeroSection from './movies-admin/components/MoviesAdminHeroSection';
import MoviesAdminPanelSection from './movies-admin/components/MoviesAdminPanelSection';
import { useFavoriteSubmission } from './movies-admin/hooks/useFavoriteSubmission';
import { useMoviesAdminSession } from './movies-admin/hooks/useMoviesAdminSession';

const isMoviesAdminSurfaceEnabled = process.env.REACT_APP_MOVIES_ADMIN_SURFACE_ENABLED !== 'false';

const MoviesAdmin = () => {
  const { sessionStatus, adminSecret, setAdminSecret, loginMessage, handleLogin, handleLogout } =
    useMoviesAdminSession({
      enabled: isMoviesAdminSurfaceEnabled,
    });

  const { formState, submitStatus, handleInputChange, handleFavoriteSubmit } =
    useFavoriteSubmission();

  return (
    <>
      <MoviesAdminHeroSection />

      <div className="site-bg-section py-20 px-6">
        <div className="container mx-auto">
          {isMoviesAdminSurfaceEnabled ? (
            <MoviesAdminPanelSection
              sessionStatus={sessionStatus}
              adminSecret={adminSecret}
              onAdminSecretChange={(event) => setAdminSecret(event.target.value)}
              loginMessage={loginMessage}
              onLogin={handleLogin}
              onLogout={handleLogout}
              formState={formState}
              onInputChange={handleInputChange}
              onFavoriteSubmit={handleFavoriteSubmit}
              submitStatus={submitStatus}
              columnOptions={COLUMN_OPTIONS}
              categorySuggestions={CATEGORY_SUGGESTIONS}
            />
          ) : (
            <section aria-labelledby="movies-admin-disabled-title" className="mb-20">
              <div className="rounded-lg border border-gray-200 bg-white p-8 text-center shadow-lg site-card">
                <h2 id="movies-admin-disabled-title" className="text-3xl font-bold text-gray-900">
                  Painel administrativo indisponivel neste deploy
                </h2>
                <p className="mt-4 text-lg text-gray-600">
                  Esta pagina publica e apenas um espelho estatico. O fluxo administrativo funciona
                  no deploy principal do Vercel, em same-origin com a API.
                </p>
              </div>
            </section>
          )}

          <MoviesAdminCtaSection />
        </div>
      </div>
    </>
  );
};

export default MoviesAdmin;
